import { render } from "./HeaderMobile.vue?vue&type=template&id=2aa07739&scoped=true"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"

import "./HeaderMobile.vue?vue&type=style&index=0&id=2aa07739&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa07739"]])

export default __exports__